module.exports = __webpack_public_path__ + "img/66.d27923f3.jpg";